import { Delete, ListAlt } from "@mui/icons-material";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";

import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";
import { useActionItemPermissions } from "../hooks/useActionItemPermissions";

export default function ActionItemRowMenu({
  anchorEl,
  open,
  onClose,
  onView,
  onEdit,
  onDelete,
  status,
  actionId = "",
}) {
  const { canEditActionItems, canDeleteActionItems } = useActionItemPermissions();
  const isDone = status === "done";
  return (
    <Menu
      id={`actionable-items-row-menu-${actionId}`}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          sx: {
            boxShadow: "none",
            borderRadius: 2,
            border: `1px solid ${HNSColors.secondary[500]}`,
            "& .MuiMenuItem-root": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
              px: 2,
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: HNSColors.tertiary[900],
            },
          },
        },
      }}
    >
      <MenuItem id={`actionable-items-row-menu-view-${actionId}`} onClick={onView}>
        <ListItemText primary="View Details" />
        <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "auto" }}>
          <ListAlt fontSize="small" sx={{ color: HNSColors.primary[500] }} />
        </ListItemIcon>
      </MenuItem>
      {canEditActionItems && !isDone && (
        <MenuItem id={`actionable-items-row-menu-edit-${actionId}`} onClick={onEdit}>
          <ListItemText primary="Edit" />
          <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "auto" }}>
            <Svg name={SvgEnum.HisEdit3} color={HNSColors.primary[500]} sx={{ width: "1.25rem" }} />
          </ListItemIcon>
        </MenuItem>
      )}
      {canDeleteActionItems && !isDone && (
        <MenuItem id={`actionable-items-row-menu-delete-${actionId}`} onClick={onDelete}>
          <ListItemText primary="Delete" sx={{ color: HNSColors.failure[500] }} />
          <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "auto" }}>
            <Delete fontSize="small" sx={{ color: HNSColors.failure[500] }} />
          </ListItemIcon>
        </MenuItem>
      )}
    </Menu>
  );
}
